import { Image } from 'components'
import Flex from 'components/priority/Flex/Flex'
import Text from 'components/priority/Text/Text'
import { Tooltip } from '@/components/global/Tooltip/Tooltip'
import Icon from 'components/priority/Icon/Icon'
import { useTranslation } from 'react-i18next'

export const PersonalImageCard = ({
  image,
  index,
  makeDefault,
  deleteImage,
  margin,
  allowDelete = true,
  showDefault = true,
  backgroundColor = '',
}) => {
  const { t } = useTranslation()
  const isFirstCard = index === 0
  const showCheck = isFirstCard && showDefault
  return (
    <Flex
      data-testid="personal-image-card"
      column
      border="1px solid"
      borderColor="gray4"
      margin={margin || '0 0 24px 0'}
      radius="4px"
      align="center"
    >
      <Flex full justify="space-between">
        <Flex>
          <Image
            data-testid="personal-image-thumbnail"
            margin="20px 20px"
            src={image}
            height="100px"
            maxWidth="95%"
            backgroundColor={backgroundColor}
          />
          {showCheck && (
            <Flex center>
              <Icon
                icon="check"
                fill="gray2"
                height="12px"
                width="12px"
                margin="0 8px 0 0"
              />
              <Text color="gray2" size="12px" weight="500">
                {t('fileDropzone.defaultImage')}
              </Text>
            </Flex>
          )}
        </Flex>
        <Flex center>
          {index !== 0 && (
            <Tooltip text={t('fileDropzone.makeDefault')} margin="0 12px 0 0">
              <div
                data-testid="personal-image-make-default"
                role="button"
                tabIndex={0}
                onClick={() => {
                  makeDefault(index)
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault()
                    makeDefault(index)
                  }
                }}
                style={{ cursor: 'pointer' }}
              >
                <Icon
                  height="16px"
                  width="16px"
                  icon="makeDefault"
                  fill="brand"
                  disabled={index === 0}
                />
              </div>
            </Tooltip>
          )}
          {allowDelete && (
            <Tooltip text={t('fileDropzone.delete')} margin="0 12px 0 0">
              <div
                data-testid="personal-image-delete"
                role="button"
                tabIndex={0}
                onClick={() => {
                  deleteImage(index)
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault()
                    deleteImage(index)
                  }
                }}
                style={{ cursor: 'pointer' }}
              >
                <Icon
                  height="16px"
                  width="16px"
                  margin="0 24px"
                  icon="archive"
                  fill="brand"
                />
              </div>
            </Tooltip>
          )}
        </Flex>
      </Flex>
    </Flex>
  )
}

export default PersonalImageCard
